import * as paths from 'constants/paths';
import { NTB_JOURNEY, PRE_ASSESSED_JOURNEY, EXISTING_JOURNEY } from 'constants/general';

export const previousRoutePaths = {
  [paths.ROOT]: {},
  [paths.ABOUT_YOUR_APPLICATION]: {
    [NTB_JOURNEY]: paths.ROOT,
    [PRE_ASSESSED_JOURNEY]: paths.INFORM_CHOICE,
    [EXISTING_JOURNEY]: paths.INFORM_CHOICE
  },
  [paths.YOUR_LOAN_OPTIONS]: {
    [NTB_JOURNEY]: paths.ABOUT_YOUR_APPLICATION,
    [PRE_ASSESSED_JOURNEY]: paths.YOUR_FINANCIAL_CIRCUMSTANCES
  },
  [paths.YOUR_LOAN_PURPOSE]: {
    [NTB_JOURNEY]: paths.YOUR_LOAN_OPTIONS,
    [PRE_ASSESSED_JOURNEY]: paths.YOUR_LOAN_OPTIONS,
    [EXISTING_JOURNEY]: paths.YOUR_LOAN_OPTIONS
  },
  [paths.SOLE_INITIAL_QUESTIONS]: {
    [NTB_JOURNEY]: paths.YOUR_LOAN_PURPOSE,
    [EXISTING_JOURNEY]: paths.DIP_YOUR_LOAN_OPTIONS
  },
  [paths.USE_OF_PERSONAL_INFORMATION]: {
    [NTB_JOURNEY]: paths.SOLE_INITIAL_QUESTIONS,
    [EXISTING_JOURNEY]: paths.SOLE_INITIAL_QUESTIONS
  },
  [paths.YOUR_PERSONAL_DETAILS]: {
    [NTB_JOURNEY]: paths.NTB_DIP_USE_OF_PERSONAL_INFORMATION
  },
  [paths.YOUR_ADDRESS_DETAILS]: {
    [NTB_JOURNEY]: paths.YOUR_PERSONAL_DETAILS
  },
  [paths.YOUR_CONTACT_DETAILS]: {
    [NTB_JOURNEY]: paths.YOUR_ADDRESS_DETAILS
  },
  [paths.INCOME_AND_EXPENSES]: {
    [NTB_JOURNEY]: paths.EMPLOYMENT_DETAILS
  },
  [paths.YOUR_FINANCIAL_CIRCUMSTANCES]: {
    [NTB_JOURNEY]: paths.SOLE_INITIAL_QUESTIONS,
    [PRE_ASSESSED_JOURNEY]: paths.ABOUT_YOUR_APPLICATION,
    [EXISTING_JOURNEY]: paths.EMPLOYMENT_DETAILS
  },
  [paths.YOUR_CHANGING_FINANCIAL_CIRCUMSTANCES]: {
    [NTB_JOURNEY]: paths.YOUR_FINANCIAL_CIRCUMSTANCES,
    [PRE_ASSESSED_JOURNEY]: paths.YOUR_FINANCIAL_CIRCUMSTANCES,
    [EXISTING_JOURNEY]: paths.YOUR_FINANCIAL_CIRCUMSTANCES
  },
  [paths.CREDIT_CARD_DETAILS]: {
    [NTB_JOURNEY]: paths.INCOME_AND_EXPENSES,
    [EXISTING_JOURNEY]: paths.DIRECT_DEBIT_INSTRUCTIONS
  },
  [paths.EMPLOYMENT_DETAILS]: {
    [NTB_JOURNEY]: paths.YOUR_CONTACT_DETAILS,
    [EXISTING_JOURNEY]: paths.REVIEW_YOUR_DETAILS //todo - this will change with customer info Lib container component
  },
  [paths.CHOOSE_A_USERNAME]: {
    [NTB_JOURNEY]: paths.DIRECT_DEBIT_INSTRUCTIONS
  },
  [paths.MARKETING_PREFERENCES]: {
    [NTB_JOURNEY]: paths.DIP_ABOUT_THIS_CHECK,
    [EXISTING_JOURNEY]: paths.YOUR_FINANCIAL_CIRCUMSTANCES,
    [PRE_ASSESSED_JOURNEY]: paths.YOUR_LOAN_AGREEMENT
  },
  [paths.YOUR_MAIN_BANK_ACCOUNT]: {
    [NTB_JOURNEY]: paths.MARKETING_PREFERENCES, //todo - this will change with customer info Lib container component
    [EXISTING_JOURNEY]: paths.YOUR_LOAN_PURPOSE
  },
  [paths.DIRECT_DEBIT_INSTRUCTIONS]: {
    [NTB_JOURNEY]: paths.YOUR_MAIN_BANK_ACCOUNT,
    [EXISTING_JOURNEY]: paths.YOUR_MAIN_BANK_ACCOUNT
  },
  [paths.REVIEW_YOUR_DETAILS]: {
    [NTB_JOURNEY]: paths.DIRECT_DEBIT_INSTRUCTIONS,
    [EXISTING_JOURNEY]: paths.CREDIT_CARD_DETAILS
  },
  [paths.REVIEW_YOUR_LOAN_DETAILS]: {
    [NTB_JOURNEY]: paths.REVIEW_YOUR_DETAILS, //todo - this will change with customer info Lib container component
    [EXISTING_JOURNEY]: paths.MARKETING_PREFERENCES //todo - this will change with customer info Lib container component
  },
  [paths.INFORMATION_ABOUT_YOUR_LOAN]: {
    [NTB_JOURNEY]: paths.REVIEW_YOUR_LOAN_DETAILS,
    [EXISTING_JOURNEY]: paths.REVIEW_YOUR_LOAN_DETAILS
  },
  [paths.ABOUT_YOUR_LOAN_INFO]: {
    [PRE_ASSESSED_JOURNEY]: paths.YOUR_LOAN_PURPOSE
  },
  [paths.YOUR_LOAN_AGREEMENT]: {
    [NTB_JOURNEY]: paths.YOUR_LOAN_AGREEMENT_PRE_CONTRACT,
    [PRE_ASSESSED_JOURNEY]: paths.YOUR_LOAN_APPROVAL,
    [EXISTING_JOURNEY]: paths.YOUR_LOAN_APPROVAL
  },
  [paths.ACCOUNT_LIST_SCREEN]: {
    [PRE_ASSESSED_JOURNEY]: paths.YOUR_LOAN_PURPOSE
  },
  [paths.INTERNAL_DEBT_CONSOLIDATE]: {
    [PRE_ASSESSED_JOURNEY]: paths.YOUR_LOAN_PURPOSE,
    [EXISTING_JOURNEY]: paths.YOUR_LOAN_PURPOSE
  },
  [paths.CONSOLIDATE_YOUR_DEBT]: {
    [NTB_JOURNEY]: paths.YOUR_LOAN_PURPOSE,
    [PRE_ASSESSED_JOURNEY]: paths.YOUR_LOAN_PURPOSE,
    [EXISTING_JOURNEY]: paths.YOUR_LOAN_PURPOSE
  },
  [paths.BEFORE_YOUR_SCREEN]: {
    [PRE_ASSESSED_JOURNEY]: paths.YOUR_FINANCIAL_CIRCUMSTANCES
  },
  [paths.YOUR_SIGNATURE_IS_NEEDED]: {
    [NTB_JOURNEY]: paths.YOUR_LOAN_AGREEMENT_PRE_CONTRACT,
    [EXISTING_JOURNEY]: paths.YOUR_LOAN_APPROVAL
  },
  [paths.DIP_PERSONAL_DETAILS]: {
    [NTB_JOURNEY]: paths.DIP_YOUR_LOAN_OPTIONS,
    [EXISTING_JOURNEY]: paths.SOLE_INITIAL_QUESTIONS
  },
  [paths.DIP_ADDRESS_DETAILS]: {
    [NTB_JOURNEY]: paths.DIP_PERSONAL_DETAILS,
    [EXISTING_JOURNEY]: paths.DIP_PERSONAL_DETAILS
  },
  [paths.DIP_EMPLOYMENT_DETAILS]: {
    [NTB_JOURNEY]: paths.DIP_ADDRESS_DETAILS,
    [EXISTING_JOURNEY]: paths.DIP_ADDRESS_DETAILS
  },
  [paths.DIP_ABOUT_THIS_CHECK]: {
    [NTB_JOURNEY]: paths.YOUR_EMPLOYMENT_DETAILS,
    [EXISTING_JOURNEY]: paths.DIP_EMPLOYMENT_DETAILS
  },
  [paths.DIP_GREAT_NEWS]: {
    [NTB_JOURNEY]: paths.DIP_ABOUT_THIS_CHECK,
    [EXISTING_JOURNEY]: paths.DIP_ABOUT_THIS_CHECK
  },
  [paths.DIP_UNLIKELY_RESULT]: {
    [NTB_JOURNEY]: paths.DIP_GREAT_NEWS,
    [EXISTING_JOURNEY]: paths.DIP_GREAT_NEWS
  },
  [paths.DIP_NO_MATCH]: {
    [NTB_JOURNEY]: paths.DIP_UNLIKELY_RESULT,
    [EXISTING_JOURNEY]: paths.DIP_UNLIKELY_RESULT
  },
  [paths.DIP_REVIEW_DETAILS]: {
    [NTB_JOURNEY]: paths.DIP_EMPLOYMENT_DETAILS,
    [EXISTING_JOURNEY]: paths.DIP_EMPLOYMENT_DETAILS
  },
  [paths.DIP_YOUR_LOAN_PURPOSE]: {
    [NTB_JOURNEY]: paths.DIP_YOUR_LOAN_OPTIONS,
    [EXISTING_JOURNEY]: paths.DIP_YOUR_LOAN_OPTIONS
  },
  [paths.DIP_CONTACT_DETAILS]: {
    [NTB_JOURNEY]: paths.DIP_GREAT_NEWS,
    [EXISTING_JOURNEY]: paths.DIP_GREAT_NEWS
  },
  [paths.DIP_MARKETING_PREFERENCES]: {
    [EXISTING_JOURNEY]: paths.DIP_CONTACT_DETAILS
  },
  [paths.DIP_YOUR_MAIN_BANK_ACCOUNT]: {
    [NTB_JOURNEY]: paths.DIP_MARKETING_PREFERENCES,
    [EXISTING_JOURNEY]: paths.DIP_GREAT_NEWS
  },
  [paths.DIP_DIRECT_DEBIT_INSTRUCTIONS]: {
    [NTB_JOURNEY]: paths.DIP_YOUR_MAIN_BANK_ACCOUNT,
    [EXISTING_JOURNEY]: paths.DIP_YOUR_MAIN_BANK_ACCOUNT
  },
  [paths.DIP_YOUR_LOAN_OPTIONS]: {
    [NTB_JOURNEY]: paths.SOLE_INITIAL_QUESTIONS
  },
  [paths.DIP_REVIEW_YOUR_LOAN_DETAILS]: {
    [NTB_JOURNEY]: paths.DIP_REVIEW_DETAILS,
    [EXISTING_JOURNEY]: paths.DIP_REVIEW_DETAILS
  },
  [paths.DIP_INFORMATION_ABOUT_YOUR_LOAN]: {
    [NTB_JOURNEY]: paths.DIP_REVIEW_YOUR_LOAN_DETAILS,
    [EXISTING_JOURNEY]: paths.DIP_DIRECT_DEBIT_INSTRUCTIONS
  },
  [paths.NTB_DIP_KEY_FEATURES]: {
    [NTB_JOURNEY]: paths.CHOOSE_A_USERNAME
  },
  [paths.NTB_DIP_USE_OF_PERSONAL_INFORMATION]: {
    [NTB_JOURNEY]: paths.SOLE_INITIAL_QUESTIONS
  },
  [paths.NTB_DIP_DECLARATION_AND_AUTHORISATION]: {
    [NTB_JOURNEY]: paths.NTB_DIP_KEY_FEATURES
  },
  [paths.YOUR_LOAN_AGREEMENT_PRE_CONTRACT]: {
    [NTB_JOURNEY]: paths.YOUR_LOAN_APPROVAL
  },
  [paths.YOUR_LOAN_AGREEMENT_POST_CONTRACT]: {
    [NTB_JOURNEY]: paths.YOUR_LOAN_AGREEMENT_PRE_CONTRACT
  },
  [paths.YOUR_CONTACT_DETAILS]: {
    [NTB_JOURNEY]: paths.YOUR_ADDRESS_DETAILS
  },
  [paths.YOUR_EMPLOYMENT_DETAILS]: {
    [NTB_JOURNEY]: paths.YOUR_ADDRESS_DETAILS
  }
};
